import { GridRowId } from "@mui/x-data-grid";
import { regions } from "../../helper/regions";
import { QuoteRatingRegion } from "./quotes";

export interface RegionData {
	id: GridRowId;
	name: string;
	[key: string]: number | string | bigint;
}

export const initialRegionData: readonly RegionData[] = [
	...Object.keys(regions).map((key, i) => ({
		id: i,
		name: key,
		lastYearAmount: 0,
		currentYearAmount: 0,
		staffNumbers: 0,
	})),
	{
		id: Object.keys(regions).length,
		name: "Total",
		lastYearAmount: 0,
		currentYearAmount: 0,
		staffNumbers: 0,
	},
];

export const mapQuoteRatingRegionsToRows = (quoteRatingRegions: QuoteRatingRegion[]) => {
    const newRows: RegionData[] = JSON.parse(JSON.stringify(initialRegionData.slice()));
    (quoteRatingRegions ?? []).forEach((region) => {
        const regionName = Object.keys(regions).find(
            (key) => regions[key] === region.ratingRegionId
        );
        if (regionName) {
            const rowIndex = newRows.findIndex((r) => r.name === regionName);
            newRows[rowIndex].lastYearAmount = region.lastYearAmount;
            newRows[rowIndex].currentYearAmount = region.currentYearAmount;
            newRows[rowIndex].staffNumbers = region.staffNumbers;
        }
    });
    return newRows;
};

export const regionDataRowsToQuoteRatingRegions = (ratingRegionsRows: RegionData[]) => {
	return (
		Object.keys(regions)
			.map((regionName) => {
				const ratingRegionId = regions[regionName];
				const row = ratingRegionsRows.find((r) => r.name === regionName);

				const lastYearAmount = Number(row?.lastYearAmount ?? 0);
				const currentYearAmount = Number(row?.currentYearAmount ?? 0);
				const staffNumbers = Number(row?.staffNumbers ?? 0);
				return {
					currentYearAmount,
					id: 0,
					lastYearAmount,
					ratingRegionId,
					ratingRegionName: regionName,
					staffNumbers,
					totalAssets: 0,
					turnoverPercentageCurrentYear: null,
					turnoverPercentageLastYear: null,
				};
			})
	);
};
